import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { fetchCurrency } from  "../Api/InvoiceApi";// assumes the user-provided function is exported here
import { fetchCompnayCodesById } from "../Api/InvoiceApi"; // note: used the exact name provided by user
import { ToastContainer, toast } from 'react-toastify';
export default function HedgeRateMaster() {
  const { user } = useAuth();

  const [currencies, setCurrencies] = useState([]);
  const [companyCodes, setCompanyCodes] = useState([]);

  const [form, setForm] = useState({
    hedgeRateCountryCode: "",
    hedgeExchangeRate: "",
    effectiveFromDate: "",
    organisationId: user?.organisationId || "",
    companyCode: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // load currencies
    const load = async () => {
      try {
        const data = await fetchCurrency();
        setCurrencies(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch currencies", err);
        setCurrencies([]);
      }

      // load company codes using organisation id from user
      try {
        if (user?.organisationId) {
          const comps = await fetchCompnayCodesById(user.organisationId);
          setCompanyCodes(Array.isArray(comps) ? comps : []);
        }
      } catch (err) {
        console.error("Failed to fetch company codes", err);
        setCompanyCodes([]);
      }
    };

    load();
  }, [user?.organisationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!form.hedgeRateCountryCode) return "Select currency";
    if (!form.hedgeExchangeRate || isNaN(Number(form.hedgeExchangeRate))) return "Enter valid exchange rate";
    if (!form.effectiveFromDate) return "Select Effective From Date";
    if (!form.organisationId) return "Organisation Id missing";
    if (!form.companyCode) return "Select Company Code";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) {
      alert(err);
      return;
    }

    setLoading(true);
    try {
      // example save endpoint - change to match your backend
      const payload = {
        HedgeRateCountryCode: form.hedgeRateCountryCode,
        HedgeExchangeRate: Number(form.hedgeExchangeRate),
        EffectiveFromDate: form.effectiveFromDate,
        OrganisationId: form.organisationId,
        CompanyCode: form.companyCode,
      };

      const res = await axios.post(`${Base_URL}/HedgeRate/CreateHedgeRate`, payload);
      if(res.status===200)
      {
         toast.success("Created");
      }
      // optionally reset or handle returned data
    } catch (error) {
      console.error(error);
      alert(error?.response?.data || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3">
      <h4>Hedge Rate Master</h4>

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group controlId="hedgeRateCountryCode">
              <Form.Label>Hedge Rate Country Code</Form.Label>
              <Form.Select
                name="hedgeRateCountryCode"
                value={form.hedgeRateCountryCode}
                onChange={handleChange}
              >
                <option value="">-- Select Currency --</option>
                {currencies.map((c) => (
                  <option key={c.code || c.id || c.currencyCode} value={c.code || c.id || c.currencyCode}>
                    {c.currencyCode}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="hedgeExchangeRate">
              <Form.Label>Hedge Exchange Rate</Form.Label>
              <Form.Control
                type="number"
                step="any"
                name="hedgeExchangeRate"
                value={form.hedgeExchangeRate}
                onChange={handleChange}
                placeholder="Enter exchange rate"
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="effectiveFromDate">
              <Form.Label>Effective From Date</Form.Label>
              <Form.Control
                type="date"
                name="effectiveFromDate"
                value={form.effectiveFromDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group controlId="organisationId">
              <Form.Label>Organisation Id</Form.Label>
              <Form.Control type="text" readOnly name="organisationId" value={form.organisationId} />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="companyCode">
              <Form.Label>Company Code</Form.Label>
              <Form.Select name="companyCode" value={form.companyCode} onChange={handleChange}>
                <option value="">-- Select Company --</option>
                {companyCodes.map((c) => (
                  <option key={c.companyCode || c.code || c.id} value={c.companyCode || c.code || c.id}>
                    {c.companyCode }-{c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4} className="d-flex align-items-end">
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button
              variant="secondary"
              className="ms-2"
              type="button"
              onClick={() => setForm({ hedgeRateCountryCode: "", hedgeExchangeRate: "", effectiveFromDate: "", organisationId: user?.organisationId || "", companyCode: "" })}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
